import { type FC } from "react";
import { Box, Chip, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ObjectItem, SelectObjectTypeConfig } from "../types";
import { ItemComponent } from "./ItemComponent";

interface SelectedObjectItemProps {
  /** Title and URL come from the form (targetTitle, targetUrl). */
  item: ObjectItem;
  /** Option of the selected target; undefined for an unknown kind. */
  config?: SelectObjectTypeConfig;
}

export const SelectedObjectItem: FC<SelectedObjectItemProps> = ({
  item,
  config,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      useFlexGap
      sx={{ minWidth: 0, overflow: "hidden" }}
    >
      <Box
        component="span"
        sx={{ minWidth: 0, overflow: "hidden", flex: "1 1 0" }}
      >
        <ItemComponent item={item} config={config} />
      </Box>
      <Chip
        label={
          config?.label ??
          t("shared.selectObject.chip", { defaultValue: "Объект" })
        }
        style={{ marginLeft: "auto", flex: "0 0 auto" }}
      />
    </Stack>
  );
};
